<template src="./Gmap.html"></template>

<script>
import GmapMixin from '../mixins/GmapMixin'

export default {
  mixins: [GmapMixin],
  created () {
    console.log('heat map!!!')
  }
}
</script>



// WEBPACK FOOTER //
// src/plugin/components/GmapHeat.vue